import { Component, EventEmitter, Input, Output } from '@angular/core';

import { AssetLocation, AssetSort, AssetViewMode } from '../models/asset-browser.model';
import { AssetType } from 'src/app/models/defines';

@Component({ selector: 'app-asset-browser-toolbar', templateUrl: './asset-browser-toolbar.component.html', styleUrls: ['./asset-browser-toolbar.component.scss'] })
export class AssetBrowserToolbarComponent {
    @Input({ required: true }) location!: AssetLocation;
    @Input() loading = false;
    @Input() fixedType: AssetType | null = null;
    @Output() back = new EventEmitter<void>();
    @Output() forward = new EventEmitter<void>();
    @Output() up = new EventEmitter<void>();
    @Output() viewModeChange = new EventEmitter<AssetViewMode>();
    @Output() upload = new EventEmitter<void>();
    @Output() createFolder = new EventEmitter<void>();
    @Output() navigateCrumb = new EventEmitter<number>();
    @Output() queryChange = new EventEmitter<string>();
    @Output() filterChange = new EventEmitter<AssetType | null>();
    @Output() sortChange = new EventEmitter<AssetSort>();

    public get crumbs(): string[] { return [this.location.scope === 'project' ? 'Project assets' : this.location.scope === 'trash' ? 'Trash' : 'Workspace', ...this.location.folderPath]; }
    public onSort(field: AssetSort['by']): void { this.sortChange.emit({ by: field, direction: this.location.sort.by === field && this.location.sort.direction === 'asc' ? 'desc' : 'asc' }); }
    public emitFilter(type: AssetType | null): void { this.filterChange.emit(this.fixedType ?? type); }
}
